<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li class="s">
            <a href="javascript:;" @click="$router.push({name: 'environment'})">{{ $t('anquanhuanbao')}}</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({name: 'welfare'})">{{ $t('welfare')}}</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({name: 'care'})">{{ $t('care')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="environment-box1">
      <div class="w1200">
        <div class="environment-box1-cont">
          <ul class="iconlist">
            <li>
              <i></i>
              <span>{{ $t('green')}}</span>
            </li>
            <li>
              <i></i>
              <span>{{ $t('ditan')}}</span>
            </li>
            <li>
              <i></i>
              <span>{{ $t('kechixu')}}</span>
            </li>
          </ul>
          {{desc}}
        </div>
      </div>
    </div>
    <div class="environment-box2"></div>
    <div class="environment-box3">
      <div class="w1200" v-html="content">
      </div>
    </div>
    <div class="environment-box4">
      <div class="w1200">
        <ul class="environment-list">
          <li v-for="(item ,index) in environments" :key="index">
            <div class="title">{{item.title}}</div>
            <div class="cont">
              <div class="left">
                <img :src="item.image" alt="">
              </div>
              <div class="right">
                 <span>
                   {{item.describe}}
                 </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="environment-box5">
      <div class="w1200">
        <div class="environment-box5-pic1">
          <img src="../assets/baii_t.png" alt="">
        </div>
        <div class="environment-box5-cont">
          <div class="left">
            <span class="sp1">{{ $t('environmentdesca')}}</span>
            <span class="sp2">{{ $t('environmentdescb')}}</span>
          </div>
          <div class="right">
            <div>
              <i></i>
              <span>{{ $t('environmentdescc')}}</span>
            </div>
            <div>
              <i></i>
              <span>{{ $t('environmentdescd')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      content: '',
      desc: '',
      environments: []
    }
  },
  mounted () {
  },
  methods: {
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 5
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/safe', {
    }).then((res) => {
      that.desc = res.result.describe
      that.content = res.result.content
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/project', {
    }).then((res) => {
      that.environments = res.result
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner5{
    background: url(../assets/pagebanner5.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    min-width: 168px;
    height: 60px;
  }
  .pagenav li a{
    display: block;
    width: auto;
    height: 100%;
    padding: 0 5px;
    line-height: 60px;
    text-align: center;
    color: #999999;
    margin: 0 5px;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
  .page-content{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 30px;
  }
  .environment-box1{
    height: auto;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 68px;
  }
  .environment-box1-cont{
    width: 100%;
    height: auto;
    line-height: 36px;
    color: #000;
  }
  .iconlist{
    width: 600px;
    height: 180px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding-left: 112px;
    padding-top: 27px;
    float: right;
  }
  .iconlist li{
    width: 80px;
    height: 100%;
    overflow: hidden;
  }
  .iconlist li i{
    width: 100%;
    height: 80px;
    display: block;
  }
  .iconlist li:nth-child(1) i{
    background: url(../assets/environmenticon1.png) 0 0 no-repeat;
  }
  .iconlist li:nth-child(2) i{
    background: url(../assets/environmenticon2.png) 0 0 no-repeat;
  }
  .iconlist li:nth-child(3) i{
    background: url(../assets/environmenticon3.png) 0 0 no-repeat;
  }
  .iconlist li span{
    display: block;
    width: 100%;
    height: 65px;
    line-height: 65px;
    text-align: center;
    font-size: 16px;
    color: #333;
  }
  .environment-box2{
    height: 261px;
    margin-top: 30px;
    background: url(../assets/environmentbox2.png) center 0 no-repeat;
  }
  .environment-box3{
    height: 517px;
    background-color: #f6f6f6;
    box-sizing: border-box;
    padding-top: 56px;
  }
  .environment-box4{
    height: auto;
    overflow: hidden;
  }
  .environment-list{
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .environment-list li{
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .environment-list li .title{
    height: 46px;
    margin-top: 10px;
    font-size: 14px;
    color: #2a2431;
    font-weight: bold;
    line-height: 40px;
  }
  .environment-list li .cont{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between
  }
  .environment-list li .left{
    width: 580px;
    height: 230px;
  }
  .environment-list li .right{
    width: 580px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .environment-list li .right span{
    display: block;
    width: 100%;
    line-height: 36px;
    font-size: 14px;
    color: #000;
  }
  .environment-box5{
    width: 100%;
    height: auto;
    overflow: hidden;
    margin-top: 58px;
  }
  .environment-box5 img{
    width: 100%;
    height: auto;
  }
  .environment-box5-cont{
    width: 100%;
    height: 186px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .environment-box5-cont .left .sp1{
    display: block;
    width: 100%;
    height: 37px;
    line-height: 37px;
    font-weight: bold;
    font-size: 16px;
    color: #999999;
  }
  .environment-box5-cont .left .sp2{
    display: block;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    height: 42px;
    line-height: 42px;
  }
  .environment-box5-cont .right{
    display: flex;
    justify-content: flex-end;
  }
  .environment-box5-cont .right div{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 24px;
    justify-content: center;
  }
  .environment-box5-cont .right div i{
    display: block;
    width: 80px;
    height: 80px;
    background:url(../assets/environmenticon4.png) 0 0 no-repeat
  }
  .environment-box5-cont .right div span{
    display: block;
    width: 100%;
    height: 28px;
    color: #999999;
    line-height: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/environment.vue